import { HasPermission } from "@getsoren/design-system";
import { lazyWithRetry } from "@getsoren/shared-module";
import { Outlet } from "react-router";

const NotFound = lazyWithRetry(() => import("@/pages/NotFound"));

interface FeatureAccessRouteProps {
  feature: string;
}

/**
 * Route that checks if a feature is enabled and renders the children if it is, otherwise renders the fallback
 * @param feature
 * @param fallback
 * @constructor
 */
const PermissionRoute = ({ feature }: FeatureAccessRouteProps) => (
  <HasPermission name={feature} fallback={<NotFound />}>
    <Outlet />
  </HasPermission>
);

export default PermissionRoute;
